import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { cn } from "@/lib/utils";

const TabsPanel = ({ 
  tabs = [], 
  value,
  defaultValue,
  onChange,
  className = ""
}) => {
  // Use first tab's value/label as default if not specified
  const initialTab = defaultValue || (tabs[0]?.value || tabs[0]?.label || "");

  // Default component for tabs without a specified component
  const DefaultComponent = ({ label }) => (
    <div className="bg-gray-100 p-4 rounded-lg h-full">
      Default content for {label}
    </div>
  );

  return (
    <Tabs 
      value={value}
      defaultValue={initialTab}
      onValueChange={onChange}
      className={cn("w-full h-full flex flex-col", className)}
    >
      <TabsList>
        {tabs.map((tab) => (
          <TabsTrigger 
            key={tab.value || tab.label} 
            value={tab.value || tab.label}
          >
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>
      <div className="flex-1 overflow-hidden"> {/* Add overflow-hidden */}
        {tabs.map((tab) => (
          <TabsContent 
            key={tab.value || tab.label} 
            value={tab.value || tab.label} 
            className="h-full flex-1 overflow-hidden" // Add overflow-hidden and flex-1
          >
            {tab.component 
              ? <div className="h-full w-full">{/* Wrap in div with full height */}
                  <tab.component />
                </div>
              : <DefaultComponent label={tab.label} />
            }
          </TabsContent>
        ))}
      </div>
    </Tabs>
  );
};

export { TabsPanel };